import { createContext, PropsWithChildren, useContext, ReactNode } from 'react';

import {
	CloudProductKey,
	ProductPlan,
} from '@/components/wpl/pricing/src/price-finder/constants.tsx';

export interface PriceFinderContextValue {
	productPlans: ProductPlan[];
	dataProductKey: CloudProductKey;
	defaultUnitCount: number;
	enterpriseMinimumCount?: number;
	isMonthlyBillingOnly?: boolean;
	isAnnualBillingOnly?: boolean;
	shouldAddDiscount?: boolean;
	contactURL?: string;
	annualUserTierDisplayThreshold?: number;
	recommendationElement?: ReactNode;
	ctaUrlSource?: PriceFinderCtaUrlSource;
}

export type PriceFinderCtaUrlSource = 'contentful' | 'productPlans';

const PriceFinderContext = createContext<PriceFinderContextValue | undefined>(undefined);

export const usePriceFinderContext = () => {
	const context = useContext(PriceFinderContext);
	if (!context) {
		throw new Error('usePriceFinderContext must be used within a PriceFinderContextProvider');
	}
	return context;
};

export interface PriceFinderContextProviderProps extends PropsWithChildren {
	dataProductKey: CloudProductKey;
	productPlans: ProductPlan[];
	defaultUnitCount: number;
	enterpriseMinimumCount?: number;
	isMonthlyBillingOnly?: boolean;
	isAnnualBillingOnly?: boolean;
	shouldAddDiscount?: boolean;
	contactURL?: string;
	annualUserTierDisplayThreshold?: number;
	recommendationElement?: ReactNode;
	ctaUrlSource?: 'contentful' | 'productPlans';
}

export const PriceFinderContextProvider = (props: PriceFinderContextProviderProps) => {
	return <PriceFinderContext.Provider value={props}>{props.children}</PriceFinderContext.Provider>;
};
